<template>
  <div class="tn-error-page">
    <span class="tn-error-page__icon"><v-icon size="40">mdi-compass-off-outline</v-icon></span>
    <p class="tn-error-page__code">404</p>
    <h2 class="tn-error-page__title">Page not found</h2>
    <p class="tn-error-page__text">The page you are looking for doesn't exist or was moved.</p>
    <v-btn depressed color="primary" exact :to="{ name: 'Home' }">
      <v-icon left size="20">mdi-arrow-left</v-icon> Back to dashboard
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

